import dataService from 'services/dataService';
import { API_PATIENT_KEY_NOTE } from 'services/dataService/resources';
import { showResult } from 'infrastructure/hooks/utils';

import type { IKeyNoteData } from 'infrastructure/interfaces';
import type { ModuleType } from 'infrastructure/enums';

interface IActionsKeyNotesProps {
  patientGuid: string;
  module: ModuleType;
  note?: string;
  expiresAt?: Date | null;
  noteGuid: string;
  showExpired: boolean;
}

export const updateKeyNotes = async ({
  patientGuid,
  module,
  note,
  expiresAt,
  noteGuid,
  showExpired,
}: IActionsKeyNotesProps) => {
  const url = API_PATIENT_KEY_NOTE(patientGuid);
  const updateData: Omit<IActionsKeyNotesProps, 'patientGuid'> = {
    module,
    note: note?.replace(/"/g, "'"),
    noteGuid,
    showExpired,
    expiresAt,
  };

  const { error, data } = await dataService.updateOnly<IKeyNoteData>(
    url,
    updateData,
  );

  if (error) {
    showResult(error);
  }

  return data;
};
